export function extractTimeFromISOString(isoString: string | undefined): string {
  if (isoString) {
    const dateObj = new Date(isoString);
    return dateObj.toTimeString().slice(0, 5); // Extract only hours and minutes (HH:mm)
  } else {
    return '';
  }
}